import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_BUSINESS_LICENSE_ORDERS_QUERY = gql`
  query BusinessLicenseOrders($businessEntity: UUID!) {
    businessLicenseOrders(businessEntity: $businessEntity) {
      orders {
        type
        orderTaskUuid
        status
      }
    }
  }
`;
